import React, { useState, useRef, useEffect } from "react";

import Autocomplete from "@material-ui/lab/Autocomplete";
import MROTextField from "components/form_components/TextField";
import { TextField } from "@material-ui/core";
import AutocompletePopper from "components/Popper";

/**
 * 
 * @param  props 
 * *options* => this prop should be an array of object with `title` and `id` key
 * @returns 
 */
function MultipleSearchableDropdown(props) {
  const {
    label,
    placeholder,
    name,
    autoFocus = true,
    required,
    error,
    helperText,
    options,
    onChange,
    multiple,
    defaultValue,
    width,
    inputValue,
    setSearchText

  } = props;

  const [value, setValue] = useState(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);
  return (
    <>
      <Autocomplete
        getOptionSelected={(option, value) => option.id === value.id}
        // value={value !== null && value}

        id="tags-standard"
        multiple={multiple ?? false}
        // defaultValue={defaultValue ?? ""}
        PopperComponent={AutocompletePopper}
        options={options ?? []}
        getOptionLabel={(option) => option.name ?? ""}
        onChange={(event, newValue) => {
          setValue(newValue);
          typeof onChange === "function" && onChange(newValue);
        }}
        onInputChange={(event, newInputValue, reason) => {
          if (inputValue) {
            if (reason === 'input' || reason === 'clear') {
              setSearchText(newInputValue || "");
            }
          }
        }}
        renderInput={(params) => (
          <MROTextField
            {...params}
            variant="outlined"
            label={label}
            name={name ?? ""}
            color={"primary"}
            placeholder={placeholder}
            InputLabelProps={{ shrink: true }}
            style={{ width: width ?? "", marginTop: "10px" }}
            autoFocus={autoFocus}
            // required={required}
            error={error && error}
            inputRef={inputRef}
          // helperText={error ? `Please select the ${label?.replace("*", "")}` : null}
          />
        )}
      />
      {/* <input value={value} name={name} style={{ display: "none" }} /> */}
    </>
  );
}

export default MultipleSearchableDropdown;
